import Vue from 'vue'
import Vuex from 'vuex'
import user from './module/user.js'

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        collapse: false,
        // 缓存组件页面
        catch_components: [],
        // 全局请求后台URL
        baseURL: 'http://localhost:8080',
        // 当前选中的菜单 - 默认选择首页
        activePath: 'home',

        // 菜单项 - 默认包含首页
        openTabs: [
            {route: '/home', name: '首页'}
        ],
        activeIndex: '/home' //激活状态
    },
    mutations: {
        // 点击标签选择菜单
        changeMenu(state, val) {
            state.activePath = val
        },
        // 添加tabs
        add_tabs(state, data) {
            this.state.openTabs.push(data);
        },
        // 删除tabs
        delete_tabs(state, route) {
            let index = 0;
            for (let option of state.openTabs) {
                if (option.route === route) {
                    break;
                }
                index++;
            }
            this.state.openTabs.splice(index, 1);
        },
        // 设置当前激活的tab
        set_active_index(state, index) {
            this.state.activeIndex = index;
        }
    },
    actions: {},
    modules: {
        user
    }
})
